/**
 * Created by rorschach on 2018/1/31.
 */
import React from "react";
// import PropTypes from 'prop-types';
import classnames from "classnames";
import NavBar from "antd-mobile/lib/nav-bar";
import "antd-mobile/lib/nav-bar/style";

import ReactComponent from "../../ReactComponent";

import "./index.scss";

const PREFIX = "xyui-navbar";

export default class extends ReactComponent {
  render() {
    const { ...others } = this.props;
    const className = classnames(this.props.className, PREFIX, {});

    const newProps = {
      ...others,
      className
    };
    return <NavBar ref="instance" {...newProps} />;
  }
}



// WEBPACK FOOTER //
// ./src/xyui/src/nav-bar/index.js